export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100/50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          关于51暗网吃瓜
        </h2>
        <div className="mt-8 space-y-4">
          <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
            51暗网吃瓜是51吃瓜旗下的热门人物专题平台，专注于为吃瓜爱好者提供台北娜娜独家爆料、莫里秀黑料揭秘、玩偶姐姐精彩视频等优质内容。我们以「暗网」之名，象征对信息深度的追求和对独家资讯的掌控力。
          </p>
          <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
            平台每日更新30+条独家爆料，覆盖100+热门人物专题，坚持一手资讯、深度挖掘的内容理念。无论是台北娜娜的最新动态，还是莫里秀的最新黑料，亦或是玩偶姐姐的精彩视频，暗网吃瓜都力争第一时间为你呈现完整、准确的吃瓜内容。
          </p>
          <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
            我们倡导理性吃瓜文化，对每条信息标注来源，引导读者健康看待娱乐八卦。感谢每一位吃瓜群众的支持与关注，51暗网吃瓜将持续为你带来最新鲜、最全面的吃瓜体验。
          </p>
        </div>
      </div>
    </section>
  );
}